import React, { useContext, useState, useEffect } from "react";
import { FiArrowLeft } from "react-icons/fi";
import CartContext from "../context/CartContext";
import UserContext from "../context/UserContext";
import UserInfo from "../components/order/UserInfo";
import BillDetails from "../components/order/BillDetails";
import CartItem from "../components/order/CartItem";
import ConfirmButton from "../components/order/ConfirmButton";
import ErrorAlert from "../components/popup/ErrorAlert";
import OrderSuccessPopup from "../components/popup/OrderSuccessPopup";

const OrderPage = ({onClose}) => {
  const cartCtx = useContext(CartContext);
  const userCtx = useContext(UserContext);
  const [popup, setPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [error, setError] = useState({
    status: false,
    message: "",
  });

  useEffect(() => {
    if (cartCtx.items.length === 0) {
      onClose();
      userCtx.showEmptyCartPopup();
    }
  }, [cartCtx.items.length, onClose, userCtx]);

  const handleOrderSuccess = () => {
    setShowSuccessPopup(true);
  };

  const handleSuccessPopupClose = () => {
    cartCtx.clearCart();
    setShowSuccessPopup(false);
    userCtx.goToHomePage();
  };

  const closeAlertPopup = () => {
    setError({
      status: false,
      message: "",
    });
  };

  const handleGoBack = () => {
    userCtx.goToHomePage();
  };

  return (
    <>
      {error.status && (
        <ErrorAlert message={error.message}>
          <div className="icon" onClick={closeAlertPopup}>
            Close
          </div>
        </ErrorAlert>
      )}

      <div className="order-container">
        <div className="oreder-main-box">
          <CartItem />
          <BillDetails />
          {/* <UserInfo /> */}
          <ConfirmButton />
        </div>
      </div>
    </>
  );
};

export default OrderPage;